import {
  Notification,
  NOTIFICATION_TYPE_CD,
} from "models/notification";

export default {
  namespaced: true,

  state: {
    notification: null,
    errorNotifications: [],
  },

  mutations: {
    RESET_STATE(state) {
      state.notification = null;
      state.errorNotifications = [];
    },
    SET_NOTIFICATOIN(state, notification) {
      state.notification = notification;
    },
    SET_ERROR_NOTIFICATIONS(state, errorNotifications) {
      state.errorNotifications = errorNotifications;
    },
    PUSH_ERROR_NOTIFICATION(state, errorNotification) {
      state.errorNotifications.push(errorNotification);
    },
    DELETE_ERROR_NOTIFICATION(state, index) {
      if (state.errorNotifications.length > index) {
        state.errorNotifications = state.errorNotifications.splice(index, index);
      }
    },
  },

  getters: {
    navbarNotification(state) {
      let notificaton = null;
      if (state.notification) {
        notificaton = {
          isError: state.notification.notificationTypeCd === NOTIFICATION_TYPE_CD.ERROR,
          message: state.notification.message,
        };
      }
      return notificaton;
    },
    navbarErrorNotifications(state) {
      const messages = [];
      state.errorNotifications.forEach((item) => {
        messages.push(item.message);
      });
      return messages;
    },
  },

  actions: {
    async resetState({ commit }) {
      commit("RESET_STATE");
      // 通知バーのDOMが更新されるまで待機する。
      const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await _sleep(100);
    },
    setNotification({ commit }, { message }) {
      const notification = new Notification();
      notification.tilte = "";
      notification.message = message;
      notification.notificationTypeCd = NOTIFICATION_TYPE_CD.NOTIFICATION;
      commit("SET_NOTIFICATOIN", notification);
    },
    setErrorNotification({ commit }, { message }) {
      const notification = new Notification();
      notification.tilte = "";
      notification.message = message;
      notification.notificationTypeCd = NOTIFICATION_TYPE_CD.ERROR;
      commit("SET_NOTIFICATOIN", notification);
    },
    clearErrorNotifications({ commit }) {
      commit("SET_ERROR_NOTIFICATIONS", []);
    },
    addErrorNotification({ commit }, message) {
      const errorNotification = new Notification();
      errorNotification.tilte = "";
      errorNotification.message = message;
      errorNotification.notificationTypeCd = NOTIFICATION_TYPE_CD.ERROR;
      commit("PUSH_ERROR_NOTIFICATION", errorNotification);
    },
    deleteErrorNotification({ commit }, index) {
      commit("DELETE_ERROR_NOTIFICATION", index);
    },
  },
};
